<template>
  <page content-class="admin-campaign-list">
    <!-- Analytics Top Card -->
    <b-card no-body class="px-4 py-2 my-2 bg-light">
      <!-- <h3>Analytics</h3> -->
      <b-row class="pt-1">
        <b-col cols="12" sm="12">
          <div class="d-flex justify-content-between">
            <h3><strong>Analytics</strong></h3>
            <!-- Campaign Selector Dropdown -->
            <b-row>
              <b-col cols="6" sm="12">
                <b-form-select
                  size="sm"
                  class="mt-1"
                  v-model="selectedCampaignID"
                  :options="campaignOptions"
                />
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <!-- Campaign Analytics Card -->
    <b-card v-if="campaign" body-class="p-4" class="mt-3">
      <!-- Campaign Title and Color -->
      <div class="d-flex justify-content-between">
        <div class="d-flex justify-content-start">
          <h3 class="ml-3">{{ campaign.title }}</h3>
        </div>
        <div>
          <b-button
            :variant="campaignAnalyticsWhereUser ? 'primary' : 'outline-primary'"
            @click="$bvModal.show('campaign-analytics-filter-user-modal')"
          >Filter by Users</b-button>
          <b-button
          :variant="campaignAnalyticsWhereJob ? 'primary' : 'outline-primary'"
            @click="$bvModal.show('campaign-analytics-filter-job-modal')"
            class="ml-3"
          >Filter by Jobs</b-button>
          <!-- b-button
            variant="outline-primary"
            class="ml-3"
          >Filter by Activity</b-button -->
        </div>
      </div>
      <!-- Overall Stats Section -->
      <div class="my-3 pt-2">
        <b-row>
          <b-col cols="12" md="6">
            <b-card title="Stats">
              <campaign-history-stats-block :stats="stats" />
            </b-card>
          </b-col>
          <b-col cols="12" md="6">
            <b-card :title="`History (${historyItems.total || 0})`">
              <campaign-history-block
                :historyItems="historyItems.entries"
                @userClicked="itemClicked($event, 'USER')"
                @jobClicked="itemClicked($event, 'JOB')"
                @contentShareClicked="itemClicked($event, 'CONTENT_SHARE')"
              />
              <div class="d-flex justify-content-center align-items-middle p-3">
                <b-pagination v-model="campaignHistoryPage" :total-rows="historyItems.total || 0" :per-page="campaignHistoryLimit" />
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>

      <!-- Jobs and content share section -->
      <div class="my-3 pt-2">
        <b-row>
          <b-col cols="12">
            <b-card title="Jobs">
              <b-alert variant="info" show>Click on the title to see detailed analytics</b-alert>
              <b-table
                striped
                hover
                :fields="[ 'title', 'points' ]"
                :items="jobs.slice((jobsPage-1) * jobsLimit, jobsPage * jobsLimit)"
              >
                <template #cell(title)="{ value, item: { id } }">
                  <span style="cursor: pointer" @click="itemClicked({ id, title: value }, 'JOB')">{{ value }}</span>
                </template>
              </b-table>
              <div class="d-flex justify-content-center align-items-middle p-3">
                <b-pagination v-model="jobsPage" :total-rows="jobs.length" :per-page="jobsLimit" />
              </div>
            </b-card>
          </b-col>
          <b-col cols="12">
            <b-card title="Content Shares">
              <b-alert variant="info" show>Click on the title to see detailed analytics</b-alert>
              <b-table
                striped
                hover
                :fields="[ 'title', 'points' ]"
                :items="contentShares.slice((contentSharesPage-1) * contentSharesLimit, contentSharesPage * contentSharesLimit)"
              >
                <template #cell(title)="{ value, item: { id } }">
                  <span style="cursor: pointer" @click="itemClicked({ id, title: value }, 'CONTENT_SHARE')">{{ value }}</span>
                </template>
              </b-table>
              <div class="d-flex justify-content-center align-items-middle p-3">
                <b-pagination v-model="contentSharesPage" :total-rows="contentShares.length" :per-page="contentSharesLimit" />
              </div>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <!-- Campaign Analytics Filter User Modal -->
    <b-modal
      id="campaign-analytics-filter-user-modal"
      title="Filter Campaign Analytics"
      size="lg"
      hide-footer
    >
      <campaign-analytics-filter-user-modal v-model="campaignAnalyticsWhereUser" />
    </b-modal>

   <!-- Campaign Analytics Filter Job Modal -->
   <b-modal
      id="campaign-analytics-filter-job-modal"
      title="Filter Campaign Analytics"
      size="xl"
      hide-footer
    >
      <campaign-analytics-filter-job-modal v-model="campaignAnalyticsWhereJob" />
    </b-modal>

    <!-- Campaign Analytics Item Profile Modal -->
   <b-modal
      id="campaign-analytics-item-profile-modal"
      title="Item Profile"
      size="xl"
      hide-footer
    >
      <campaign-analytics-item-profile-modal :campaign="campaign" :item="selectedItem" />
    </b-modal>
  </page>
</template>

<script>
import gql from 'graphql-tag';
import Page from '@/components/campaign-admin/page';
import StatsBlock from '@/components/campaign-admin/StatsBlock.vue';
import ComponentStats from '@/components/campaign-admin/ComponentStats.vue';
import CampaignHistoryBlock from '@/components/campaign-admin/CampaignHistoryBlock.vue';
import CampaignHistoryStatsBlock from '@/components/campaign-admin/CampaignHistoryStatsBlock.vue';
import CampaignAnalyticsFilterUserModal from '@/components/campaign-admin/CampaignAnalyticsFilterUser.vue';
import CampaignAnalyticsFilterJobModal from '@/components/campaign-admin/CampaignAnalyticsFilterJob.vue';
import CampaignAnalyticsItemProfileModal from '@/components/campaign-admin/CampaignAnalyticsItemProfile.vue';
import CampaignAnalyticsQuery from '@/graphql/queries/CampaignAnalytics.gql';

const CampaignsListStatsQuery = gql`
  query CampaignsListStats {
    company {
      id
      campaigns {
        id
        title
      }
    }
  }
`;

export default {
  components: {
    Page,
    StatsBlock,
    ComponentStats,
    CampaignHistoryBlock,
    CampaignHistoryStatsBlock,
    CampaignAnalyticsFilterUserModal,
    CampaignAnalyticsFilterJobModal,
    CampaignAnalyticsItemProfileModal
  },
  data: () => ({
    selectedCampaignID: null,
    selectedItem: null,
    campaignAnalyticsWhereUser: null,
    campaignAnalyticsWhereJob: null,
    campaign: null,
    campaignHistoryLimit: 5,
    campaignHistoryPage: 1,
    jobsLimit: 5,
    jobsPage: 1,
    contentSharesLimit: 5,
    contentSharesPage: 1
  }),
  apollo: {
    campaigns: {
      query: CampaignsListStatsQuery,
      update({ company }) {
        const { campaigns } = company;
        return campaigns;
      },
      result({ data }) {
        const { campaigns } = data.company || {};
        const [ campaign ] = Array.isArray(campaigns) ? campaigns : [];
        if (this.$route.query && this.$route.query.campaignID) {
          this.selectedCampaignID = this.$route.query.campaignID;
        } else {
          this.selectedCampaignID = (campaign || {}).id;
        }
        return campaigns;
      },
      error(err) {
        this.$notifyFatalErr(err, { prepend: 'Failed to load the campaigns' });
      },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
    campaign: {
      query: CampaignAnalyticsQuery,
      variables() {
        const { selectedCampaignID, campaignHistoryLimit, campaignHistoryPage, campaignAnalyticsWhereUser, campaignAnalyticsWhereJob } = this;
        const where = {};
        if (campaignAnalyticsWhereUser) {
          where.users = { scim: campaignAnalyticsWhereUser };
        }
        if (campaignAnalyticsWhereJob) {
          where.jobs = campaignAnalyticsWhereJob;
        }
        return {
          campaignWhere: { id: selectedCampaignID },
          ...(Object.keys(where).length ? { campaignHistoryWhere: where } : {}),
          campaignHistoryLimit,
          campaignHistoryPage
        };
      },
      update({ company }) {
        const { campaign } = company;
        return campaign;
      },
      error(err) {
        this.$notifyFatalErr(err, { prepend: 'Failed to load the campaign analytics' });
      },
      skip() {
        return !this.selectedCampaignID;
      },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
  },
  computed: {
    campaignOptions() {
      const { campaigns } = this;
      return (campaigns || []).map(({ id, title }) => ({ value: id, text: title }));
    },
    historyItems() {
      const { campaign } = this;
      const { history } = campaign || {};
      const { historyItems } = history || {};
      const { entries, total } = historyItems || {};
      console.log({ entries, total });
      return {
        entries: Array.isArray(entries) ? entries : [],
        total,
      };
    },
    stats() {
      const { campaign } = this;
      const { history } = campaign || {};
      const { stats } = history || {};
      console.log({ stats });
      return stats;
    },
    jobs() {
      const { campaign } = this;
      const { history } = campaign || {};
      const { jobs } = history || {};
      return jobs
        .filter(({ job }) => job)
        .map(({ job, points }) => ({
          id: job.id,
          title: `${(job || {}).title} ${(job || {}).location ? `(${(job || {}).location.name}, ${(job || {}).location.countryName})` : job.customFieldsHash && job.customFieldsHash.location ? `(${job.customFieldsHash.location})` : ''}`,
          points
        }))
        .sort((a, b) => b.points - a.points);
    },
    contentShares() {
      const { campaign } = this;
      const { history } = campaign || {};
      const { contentShares } = history || {};
      console.log({ contentShares });
      return contentShares
        .filter(({ contentShare }) => contentShare)
        .map(({ contentShare, points }) => ({ id: contentShare.id, title: (contentShare || {}).title, points }))
        .sort((a, b) => b.points - a.points);
    }
  },
  methods: {
    itemClicked(item, type) {
      item.type = type;
      if (type === 'USER') {
        item.title = `${item.firstName} ${item.lastName}`;
      }
      this.selectedItem = item;
      this.$bvModal.show('campaign-analytics-item-profile-modal');
    }
  }
};
</script>

<style lang="scss">
    .referral-jam-event-settings {
        .event-logo {
            max-height: 30px;
            max-width: 200px;
        }
    }
    .link-styling {
      text-decoration: underline;
      cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/views/campaign-admin/CampaignAnalyticsV2.vue